export default {"src":"/_next/static/media/lounge.02cc08dd.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};